import { render, staticRenderFns } from "./Escolhe_processo.vue?vue&type=template&id=63978bbd&"
import script from "./Escolhe_processo.vue?vue&type=script&lang=js&"
export * from "./Escolhe_processo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports